export const CONVERT_GENERIC_HTML_TO_PDF = 'CONVERT_GENERIC_HTML_TO_PDF';
export const CONVERT_GENERIC_HTML_TO_PDF_SUCCESS = 'CONVERT_GENERIC_HTML_TO_PDF_SUCCESS';
export const CONVERT_GENERIC_HTML_TO_PDF_FAIL = 'CONVERT_GENERIC_HTML_TO_PDF_FAIL';

export const convertGenericHtmlToPdf = payload => ({
    type: CONVERT_GENERIC_HTML_TO_PDF,
    payload,
});
